import i18n from "@/i18n";
import Trans from "@/i18n/translition";
import type { ILocale } from "@/@types/shared/locale";

export function getLocale(data: ILocale): string {
  if (!data) return "ㅤ";
  const pref = process.env.VUE_APP_I18N_FALLBACK_LOCALE;
  const i18pref = String(i18n.global.fallbackLocale);
  const keys = Object.keys(data);
  const locale = Trans.locale;
  if (keys.includes(locale)) return data[locale];
  if (pref && keys.includes(pref)) return data[pref];
  if (keys.includes("en")) return data["en"];
  if (keys.includes(i18pref)) return data[i18pref];

  return keys.length ? data[keys[0]] : "ㅤ";
}
